import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Inset } from 'syf-component-library/ui/spacing';
import { MessageBox } from '@account-services-mfe/core';
import triggerPaymentSecurityAnalytics from '../../../../../helpers/trigger-payment-security-analytics';
import { ScreenWrapper } from '../subcomponents';
import PaymentSecurityHeader from '../../header';
import Content from '../../../../common/content';
import PaymentSecurityDebtCancellation from '../../../../common/payment-debt-cancellation';
import { PAGE_NAME } from '../../../../../const/analytics';
import MessageBoxContainer from '../../../../common/MessageBoxContainer';
const Cancelled = () => {
    const { t } = useTranslation();
    useEffect(() => {
        triggerPaymentSecurityAnalytics({
            pageName: PAGE_NAME.CANCELLED,
            errorMessage: t('cancelled.errorMessage.title')
        });
    }, [t]);
    return (_jsxs(ScreenWrapper, { children: [_jsx(PaymentSecurityHeader, { title: t('cancelled.header.title'), subtitle: t('common.header.subtitle') }), _jsx(MessageBoxContainer, { children: _jsx(MessageBox, { type: "error", messageTitle: t('cancelled.errorMessage.title'), messageDescription: t('cancelled.errorMessage.description') }) }), _jsx(Inset, { horizontal: "large", children: _jsx(Content, { children: _jsx(PaymentSecurityDebtCancellation, {}) }) })] }));
};
export default Cancelled;
